module.exports = __webpack_public_path__ + "img/setting-cam-detail_sp.png";